<template>
  <div class="image-upload-wrapper">
    <!--<label class="form-control-label"> {{ label }} </label>-->
    <div class="image-upload">
      <div class="image-upload-picture">
        <div v-if="image" class="profile-image">
          <img :src="`${image}`" class="profile-image argon-image" />
        </div>
        <div v-else class="profile-image default">
          <img src="/img/add-image.svg" class="argon-image" />
        </div>
      </div>
      <div class="image-upload-buttons">
        <base-button
          v-if="image"
          type="button"
          class="btn btn-sm remove"
          @click="removeImage"
        >
          <span>
            <!--<i class="fa fa-times" />
            {{ $t("COMMON.REMOVE_IMAGE") }}-->
            <i class="fal fa-trash-alt"></i>
          </span>
        </base-button>
        <base-button type="button" class="btn btn-sm choose">
          <label v-if="!image" :for="`imageInput-${componentId}`">
            <!--{{ $t("COMMON.SELECT_IMAGE") }}-->
          </label>
          <label v-else :for="`imageInput-${componentId}`">
            <!--{{ $t("COMMON.CHANGE_IMAGE") }}-->
          </label>
          <!--<label :for="`imageInput-${componentId}`"></label>-->
          <input
            :id="`imageInput-${componentId}`"
            :ref="`imageInput-${componentId}`"
            accept="image/*"
            type="file"
            @input="onFileChange"
          />
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "image-selector",

  props: {
    defaultImage: {
      type: String,
      default: null,
      description: "Default image to diplay, should be model value",
    },
    label: {
      type: String,
      default: null,
      description: "Label of the field",
    },
    ressource_name: {
      type: String,
      default: null,
      description:
        "Ressource name to be uploaded with, must be allowed in the api",
    },
    ressouce_id: {
      type: String,
      default: null,
      description:
        "Ressource id to be uploaded with, must be allowed in the api",
    },
    field: {
      type: String,
      default: null,
      description:
        "Ressource field to be uploaded with, must be allowed in the api",
    },
  },

  setup() {},

  data() {
    return {
      image: this.defaultImage,
      componentId: null,
    };
  },

  mounted() {
    this.componentId = this._uid;
  },

  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadImage(files[0]);
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async uploadImage(file) {
      if (file) {
        try {
          const isSvg = file.type === "image/svg+xml" || file.name.endsWith(".svg");

          // Si SVG → convertir en PNG
          if (isSvg) {
            // Upload du SVG original
            await this.$store.dispatch("files/upload", {
              image: file,
              ressource_name: this.ressource_name,
              ressource_id: this.ressource_id,
              field: this.field,
            });
            const svg_url = this.$store.getters["files/url"];
            this.$emit("imageChanged", svg_url);

            // Conversion → PNG
            const pngFile = await this.convertSvgToPng(file);
            if (!pngFile) throw new Error("SVG conversion failed");

            // Upload du PNG converti
            await this.$store.dispatch("files/upload", {
              image: pngFile,
              ressource_name: this.ressource_name,
              ressource_id: this.ressource_id,
              field: this.field,
            });

            const image_url = this.$store.getters["files/url"];
            this.$emit("imageConverted", image_url);
            return;
          }
          await this.$store.dispatch("files/upload", {
            image: file,
            ressource_name: this.ressource_name,
            ressource_id: this.ressource_id,
            field: this.field,
          });
          const image_url = await this.$store.getters["files/url"];
          this.$emit("imageChanged", image_url);
        } catch (error) {
          console.log(error);
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
        }
      }
    },

    downloadFile(file) {
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name; // nom du fichier ex: logo.png
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    async convertSvgToPng(svgFile) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          const svgData = e.target.result;
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(svgData, "image/svg+xml");
          const svgEl = svgDoc.documentElement;

          // 🔹 Lecture width/height + conversion en pixels
          let width = svgEl.getAttribute("width");
          let height = svgEl.getAttribute("height");
          const viewBox = svgEl.getAttribute("viewBox");

          const unitToPx = (value) => {
            if (!value) return null;
            const num = parseFloat(value);
            if (isNaN(num)) return null;
            if (value.endsWith("in")) return num * 96;          // 1 inch = 96 px
            if (value.endsWith("cm")) return num * 37.8;        // 1 cm ≈ 37.8 px
            if (value.endsWith("mm")) return num * 3.78;        // 1 mm ≈ 3.78 px
            if (value.endsWith("pt")) return num * 1.3333;      // 1 pt = 1.333 px
            if (value.endsWith("pc")) return num * 16;          // 1 pc = 16 px
            return num; // si déjà en px ou sans unité
          };

          let w = unitToPx(width);
          let h = unitToPx(height);

          // 🔸 Si pas trouvé → utiliser viewBox
          if ((!w || !h) && viewBox) {
            const parts = viewBox.split(" ").map(Number);
            if (parts.length === 4) {
              w = w || parts[2];
              h = h || parts[3];
            }
          }

          // Valeurs par défaut au cas où
          if (!w || !h) {
            w = 400;
            h = 400;
          }

          const img = new Image();
          const blob = new Blob([svgData], { type: "image/svg+xml" });
          const url = URL.createObjectURL(blob);

          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");

            try {
              ctx.drawImage(img, 0, 0, w, h);
            } catch (err) {
              URL.revokeObjectURL(url);
              reject(new Error("Canvas draw failed, possibly due to CORS."));
              return;
            }

            canvas.toBlob(
              (blob) => {
                URL.revokeObjectURL(url);
                if (!blob) {
                  reject(new Error("PNG conversion failed (empty canvas)."));
                  return;
                }
                const pngFile = new File(
                  [blob],
                  svgFile.name.replace(/\.svg$/i, ".png"),
                  { type: "image/png" }
                );
                resolve(pngFile);
              },
              "image/png",
              1.0
            );
          };

          img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("SVG image loading failed."));
          };

          img.src = url;
        };

        reader.onerror = reject;
        reader.readAsText(svgFile);
      });
    },

    removeImage() {
      this.$refs[`imageInput-${this.componentId}`].value = null;
      this.image = null;
      this.$emit("imageChanged", null);
    },
  },

  watch: {
    defaultImage(defaultImage) {
      this.image = defaultImage;
    },
  },
};
</script>

<style lang="scss">
.image-upload-wrapper {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin: 10px 0 1.5rem 0;

  .image-upload {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0 auto 0 0;
    padding: 0;

    &:hover {
      button.remove {
        visibility: visible;
        opacity: 1;
      }
    }

    &-picture {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      position: relative;
      z-index: 9;

      .profile-image {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        &.default {
          img {
            width: 43px;
            height: auto;
            border-radius: 0;
          }
        }

        img {
          width: 100%;
          height: 100%;
          padding: 0;
          border-radius: 50%;
          object-fit: contain;
          border: none;
        }
      }
    }

    &-buttons {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;

      button {
        width: 100%;
        height: 100%;
        display: flex;
        border-radius: 50%;
        background-color: transparent;
        border: none;
        box-shadow: none;
        padding: 0;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        transition: all 0.3s ease;
        position: absolute;
        top: 0;
        left: 0;

        &:hover {
          box-shadow: none;
          transform: none;
        }

        &.remove {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          opacity: 0;
          visibility: hidden;
          background-color: rgb(255, 0, 0, 0.6);
          z-index: 2;
          margin: 0;
          i {
            color: #fff;
            font-size: 30px;
          }
        }

        .choose {
          z-index: 1;
        }

        label {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          flex-direction: row;
          background-color: transparent;
          margin: 0;
          cursor: pointer;
        }

        input {
          display: none;
        }
      }
    }
  }
}
</style>
